import React from 'react';

import { withInteractiveStore } from './TemplateWithInteractiveStore';
import { SanitizedHtml } from './SanitizedHtml';
import { Instructions } from './Instructions';

const massageListItems = (listItems = '') => {
  /**
   * @todo
   * better approach would be to validate/modify the text going into the RTE.
   */
  // strips <p>, <br>, <ul> and new lines. 
  listItems = listItems.replace(/(<[^>]?(p|ul|br).*?>)|\n/g, '');
  if (!listItems) {
    return null;
  }
  if (!listItems.match(/^<li>.*<\/li>$/g)) {
    listItems = `<li>${listItems}</li>`;
  }
  return listItems;
}

const ProgressionWithoutStore = ({ assets, interactive, ...props }) => {
  const { detailsLayout, id, title, topics = [], topicLayout } = interactive;
  const showInstructions = props.forwardedRef ? true : false;

  const renderDetailsNav = (topic,screenNo) => {
    let prevBtn = '';
    let nextBtn = '';
    const index = screenNo - 1;
    const currentTab = <div 
                          key="currentTab"
                          className="btn dinfos-btn dinfos-conpro__details-nav-item dinfos-conpro__details-nav-item--active" 
                          data-theme={topic.theme}
                        >
                          {topic.title}
                        </div>
              
    // if first slide, prevBtn goes to last slide
    if (screenNo !== 1 && topics[screenNo - 1]) {
      prevBtn = <button 
        key="prevBtn"
        type="button" 
        className="btn dinfos-btn dinfos-conpro__details-nav-item dinfos-conpro__details-nav-item--prev" 
        data-go-to-screen={screenNo - 1}  data-theme={topics[index - 1].theme}
      >
          <i className="fas fa-arrow-left"></i><span className="sr-only">Move back to </span><span className="dinfos-conpro__details-nav-item-text">{topics[index - 1]['title']}</span>
      </button>
    } else if ( topics.length > 1) {
      prevBtn = <button 
        key="prevBtn"
        type="button" 
        className="btn dinfos-btn dinfos-conpro__details-nav-item dinfos-conpro__details-nav-item--prev" 
        data-reverse 
        data-go-to-screen={topics.length}  
        data-theme={topics[topics.length - 1].theme}
      >
        <i className="fas fa-arrow-left"></i><span className="sr-only">Move to </span><span className="dinfos-conpro__details-nav-item-text">{topics[topics.length - 1]['title']}</span>
      </button>
    }
    
    // if last slide, nextBtn goes to first slide
    if (screenNo === topics.length ) {
      nextBtn = <button 
                  key="nextBtn" 
                  type="button" 
                  className="btn dinfos-btn dinfos-conpro__details-nav-item dinfos-conpro__details-nav-item--next" 
                  data-reverse data-go-to-screen="1" 
                  data-theme={topics[0].theme}
                >
                  <span className="sr-only">Move on to </span><span className="dinfos-conpro__details-nav-item-text">{topics[0]['title']}</span>
                  <i className="fas fa-arrow-right"></i>
                </button>
    } else {
      nextBtn = <button 
                  key="nextBtn" 
                  type="button" 
                  className="btn dinfos-btn dinfos-conpro__details-nav-item dinfos-conpro__details-nav-item--next" 
                  data-go-to-screen={screenNo + 1} 
                  data-theme={topics[index + 1].theme}
                >
                  <span className="sr-only">Move on to </span><span className="dinfos-conpro__details-nav-item-text">{topics[index + 1]['title']}</span>
                  <i className="fas fa-arrow-right"></i>
                </button>
    }
    
    return [prevBtn,currentTab,nextBtn];
  }

  if (!topics || topics.length < 1) {
    return 'You must add at least one topic to see a preview.';
  }

  return (
    <div id="interactive-template" ref={props.forwardedRef}>
      <div className="dinfos-intv__wrapper"> 
        <section className={`dinfos-conpro${ topicLayout === 'stacked' ? ' dinfos-conpro--stacked' : '' } dinfos-conpro--details-${detailsLayout} ${showInstructions ? 'overflow-hidden' : ''}`} id={id} data-intv>
          <h2 className="sr-only">
            <SanitizedHtml content={title}/>
          </h2>

          <Instructions hide={!showInstructions} instructions="Use labels along the top to progress through scenarios. Click the learn more button for more in-depth information." id={`${id}-instr`} />
          
          <div className="dinfos-conpro__nav">
            
            <button 
              type="button" 
              className="btn dinfos-btn dinfos-conpro__nav-item dinfos-conpro__nav-item--prev d-none" 
              data-prev
            >
              <i className="fas fa-arrow-left"></i><span className="sr-only">Move to previous topic</span>
            </button>
            
            {topics.map((topic, index) => {
              const screenNo = index + 1;
              return (
                <h2 key={index}>
                  <button 
                    type="button" 
                    id={`${id}-tab-${screenNo}`}
                    className="btn dinfos-btn dinfos-conpro__nav-item" 
                    aria-expanded={ index === 0 ? 'true' : 'false' }
                    data-go-to-screen={screenNo}
                    data-theme={topic.theme} 
                    aria-controls={`${id}-topic-${screenNo}`}>
                      {topic.title}
                  </button>
                </h2>
              )
            })}


            <button 
              type="button" 
              className="btn dinfos-btn dinfos-conpro__nav-item dinfos-conpro__nav-item--next" 
              data-go-to-screen="2"
            >
              <span className="sr-only">Move to next topic"</span><i className="fas fa-arrow-right"></i>
            </button>

          </div>    

          <div className="dinfos-conpro__track">

            {topics.map((topic, index) => {
              const screenNo = index + 1;
              return (
                <div 
                  key={index}
                  className={`dinfos-conpro__topic ${ index === 0 ? 'dinfos-conpro__topic--active' : ''}`}
                  aria-labelledby={`${id}-tab-${screenNo}`}
                  style={topic.bg && topic.bg.src ? {backgroundImage: 'url(' + assets[topic.bg.src] + ')'} : {}} 
                  data-src={topic.bg && topic.bg.src ?  topic.bg.src : null} 
                  data-screen={screenNo} 
                  data-theme={topic.theme} 
                  id={`${id}-topic-${screenNo}`}>

                  {/* graphic title */}
                  <h2 className="dinfos-conpro__title" aria-hidden="true">
                    <SanitizedHtml content={title} keepLineBreaks={true}/>
                  </h2>

                  <div className="dinfos-conpro__main">
                    <div className="dinfos-conpro__condition">
                      <div className="dinfos-conpro__condition-title">
                        <SanitizedHtml content={topic.subtitle1} />
                      </div>

                      {topic.listItems
                        ? <SanitizedHtml className="dinfos-conpro__condition-items" tag="ul" content={massageListItems(topic.listItems)} />
                        : ''
                      }

                    </div>

                    <div className="dinfos-conpro__then">

                      <div className="dinfos-conpro__then-pretitle">
                        <SanitizedHtml content={topic.subtitle2a} />
                      </div>

                      <div className={`dinfos-conpro__then-title ${topic.smallSubtitle2b === 'md' ? 'dinfos-conpro__then-title--smaller' : ''}`}>
                        
                        {topic.subtitle2b}

                        <button 
                          type="button" 
                          className="btn dinfos-btn dinfos-conpro__open" 
                          data-open-details={`#${id}-details-${screenNo}`}
                        >
                          <i className="fas fa-plus"></i>Learn More<span className="sr-only"> about {topic.subtitle2b}</span>
                        </button>

                      </div>

                    </div>

                  </div>

                  { topic.details 
                    ? <section 
                        className={`dinfos-conpro__details d-none`} 
                        id={`${id}-details-${screenNo}`} 
                        aria-labelledby={`${id}-details-${screenNo}-title`}
                      >
                    
                      <div className="dinfos-conpro__overlay"></div>
                      <div className="dinfos-conpro__details-doc">

                        <header 
                          className="dinfos-conpro__header"
                          style={topic.details && topic.details.headerImage && topic.details.headerImage.src ? {backgroundImage: `url(${assets[topic.details.headerImage.src]})`} : {background: '#aaa'}} 
                          data-src={topic.details && topic.details.headerImage && topic.details.headerImage.src ? topic.details.headerImage.src : null}
                        >
                          <button 
                            type="button" 
                            className="btn dinfos-btn dinfos-conpro__close" 
                            aria-label={`Close ${topic.subtitle2b} dialog`}
                            data-close-details
                          >
                              <i className="fas fa-times"></i>
                          </button>
                          
                          <h3 className="dinfos-conpro__details-title" id={`${id}-details-${screenNo}-title`}>
                            {topic.details.title}
                            <br/>
                            <span className='highlight'>{topic.details.subtitle}</span>
                          </h3>

                          {topic.details.keywords
                            ? <SanitizedHtml className="dinfos-conpro__keywords" tag="ul" content={massageListItems(topic.details.keywords)} />
                            : ''
                          }

                        </header>


                        <div className="dinfos-conpro__body">
                          <div className="dinfos-conpro__summary">
                            <SanitizedHtml content={topic.details.intro} />
                          </div>

                          { topic.details.image 

                            ? <div className="dinfos-image__wrapper dinfos-image__wrapper--center">
                              <figure className="dinfos-image">
                                
                                <img src={assets[topic.details.image.src]} alt={topic.details.image.alt} data-src={topic.details.image.src} />

                                <figcaption>
                                  <i className="fas fa-camera mr-2" aria-hidden="true"></i>
                                  {topic.details.image.caption}&nbsp;
                                  <span className="sr-only">Photo by</span>
                                  <span className="dinfos-credit">{topic.details.image.credit}</span>
                                </figcaption>

                              </figure>
                            </div>

                            : '' 
                          }

                          {topic.details.sections

                            ? <div className="dinfos-conpro__sections">
                              {topic.details.sections.map((section,index) => (
                                <div className="dinfos-conpro__section" key={index}>
                                  {section.title ? 
                                    <h4>
                                      { section.icon ? 
                                        <i className={`fa${section.iconSet} fa-${section.icon}`}></i> 
                                      : '' }
                                      <SanitizedHtml content={section.title.replace(/<[^>]?p>/g, '')} />
                                    </h4>
                                  : '' }
                                  <div className="dinfos-conpro__section-text">
                                    <SanitizedHtml content={section.richText} />
                                  </div>
                                </div>
                              ))}
                            </div>

                            : ''
                          }

                        </div>

                        <div className="dinfos-conpro__details-nav">
                          {renderDetailsNav(topic,screenNo)}  
                        </div>

                      </div>
                    </section>
                    : '' 
                  }

                </div>
              )
            })}
          
          </div>

        </section>
      </div>
    </div>
  )


}

export const Progression = withInteractiveStore(
  ProgressionWithoutStore,
);